import api from './index';

export default {
  getOrder(id) {
    return api.get(`/order/${id}`);
  },
  sendOrder(order) {
    return api.post('/order', order);
  },
  getPayLink(parameters) {
    return api.get(`/pay/${parameters.id}?redirect_url=${parameters.redirect_url}`);
  },
};
